import { render, staticRenderFns } from "./PaymentIcons.vue?vue&type=template&id=4c96351b&scoped=true&"
import script from "./PaymentIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentIcons.vue?vue&type=script&lang=js&"
import style0 from "./PaymentIcons.vue?vue&type=style&index=0&id=4c96351b&prod&lang=postcss&"
import style1 from "./PaymentIcons.vue?vue&type=style&index=1&id=4c96351b&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96351b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
